import { SuburbanFloorsContainer } from '../../containers/advancedFilters/SuburbanFloorsContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanFloors: IFilter = {
  component: SuburbanFloorsContainer,
};
